import React from 'react';
import { Loader } from 'semantic-ui-react';

const Loading = () => {
  return <Loader inline="centered" active style={{ marginTop: '250px' }} />;
};

export default Loading;
